import styled from 'styled-components'

import { TransparentIconButton } from '../../Button'

export const DatepickerPrevNavButton = styled((props) => {
  return (
    <TransparentIconButton
      icon='chevron-thick-left'
      {...props}
      aria-label='Previous'
    />
  )
})`
  position: absolute;
  top: ${(props) => props.theme.typography.pxToRem(18)};
  left: ${(props) => props.theme.typography.pxToRem(20)};
`
